import { createContext, useContext } from "react";

import { useFindOneGeneralCurrentPublicSettings } from "../hooks/useFindOneGeneralCurrentPublicSettings";
import { useFindSettingsSpaces } from "../hooks/useFindSettingsSpaces";

interface ISettingsCurrentPublicContext {
	data: any;
	isLoading: boolean;
	isError: boolean;

	space: any;
	isLoadingSpace: boolean;
	isErrorSpace: boolean;
}

const SettingsCurrentPublicContext = createContext({
	isError: true,
} as ISettingsCurrentPublicContext);

export const SettingsCurrentPublicProvider = ({ children }: any) => {
	const { data, isLoading, isError } = useFindOneGeneralCurrentPublicSettings()
	const { space, isLoadingSpace, isErrorSpace, } = useFindSettingsSpaces()

	return (
		<SettingsCurrentPublicContext.Provider
			value={{
				data,
				isLoading,
				isError,
				space,
				isLoadingSpace,
				isErrorSpace,
			}}
		>
			{children}
		</SettingsCurrentPublicContext.Provider>
	);
};

export const useCurrentPublicSettings = () => {
	const context = useContext(SettingsCurrentPublicContext);
	if (context === undefined) {
		throw new Error("You must be inside a SettingsCurrentPublicContext");
	}
	return context;
};
